import {
  Box,
  Grid,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import RefreshIcon from "@material-ui/icons/Refresh";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Form, Formik } from "formik";
import MaterialTable from "material-table";
import { DropzoneArea } from "material-ui-dropzone";
import Labels from "../../../../../lang/Labels_en";
import { getTypeFromNameFile, handleFileType, preventDefaultEnter } from "../../../../../utils/Utils";
import HtmlTooltip from "../../../../system/html-tooltip/HtmlTooltip";
import { tableIcons } from "../../../../system/material-table-utils/MaterialTableUtils";
import { manuscriptFigures } from "../TooltipText";
import PaperFilesService, { PaperFilesServiceType } from "./PaperFilesService";
import useStyles from "./PaperFilesStyle";

const SIZE_1MB = 1048576;

export default function PaperFiles({ article, setArticle, handleNext, handleBack }: any) {
  const classes = useStyles();

  const {
    uploadFile,
    articleSave,
    designationOptions,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    handleResetDialog,
    files,
    uploading,
    deleteFile,
    filesByDesignation,
    selectedDesigantion,
    deleteFileGroup,
  }: PaperFilesServiceType = PaperFilesService({
    article,
    setArticle,
    handleNext,
  });

  const filesComponent = (files: any) => (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{Labels.TITLE}</TableCell>
            <TableCell>{Labels.FILE_TYPE}</TableCell>
            <TableCell>{Labels.ACTION}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {files.map((file: any) => (
            <TableRow key={file.id}>
              <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>
                <Link href={file?.location} color="inherit" component="a" target="_blank">
                  {file?.filename}
                </Link>
              </TableCell>
              <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>{file.fileType}</TableCell>
              <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>
                <IconButton aria-label="delete" onClick={() => deleteFile(file.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <div>
      <CssBaseline />
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: Labels.FILE_NAME, field: "id", hidden: true },
              {
                title: Labels.FILE_NAME,
                field: "name",
                cellStyle: (data, rowData: any) => ({
                  color: rowData?.color,
                  maxWidth: "30%",
                }),
                render: (rowData: any) =>
                  [Labels.MANUSCRIPT, Labels.TABLES].includes(rowData?.designation) && rowData?.location ? (
                    <Link href={rowData?.location} color="inherit" component="a" target="_blank">
                      {rowData?.name}
                    </Link>
                  ) : [Labels.FIGURE, Labels.SUPPLEMENTARY_FIGURE, Labels.ADDITIONAL_FILE, Labels.VIDEO_FILE].includes(
                      rowData?.designation
                    ) && rowData?.files?.length > 0 ? (
                    filesComponent(rowData.files)
                  ) : (
                    rowData?.name
                  ),
              },
              {
                title: Labels.FILE_DESIGNATION,
                field: "designation",
                render: ({ tooltip, designation, color }: any) => (
                  <Box display="flex">
                    <Typography>{designation}</Typography>
                    {tooltip && (
                      <HtmlTooltip title={tooltip} interactive>
                        {[Labels.FIGURE, Labels.SUPPLEMENTARY_FIGURE].includes(designation) ? (
                          <ErrorOutlineIcon fontSize="small" className={classes.helpIcon} />
                        ) : (
                          <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                        )}
                      </HtmlTooltip>
                    )}
                  </Box>
                ),
                cellStyle: (data, rowData: any) => ({
                  color: rowData?.color,
                }),
              },
              {
                title: Labels.FILE_TYPE,
                field: "type",
                cellStyle: (data, rowData: any) => ({
                  color: rowData?.color,
                }),
              },
            ]}
            data={filesByDesignation}
            options={{
              actionsColumnIndex: -1,
              pageSize: 10,
              search: false,
            }}
            actions={[
              ({ showAdd, code }) => ({
                icon: () => <AddIcon color="action" />,
                tooltip: Labels.ADD,
                hidden: !showAdd,
                position: "row",
                onClick: (event: any) => handleOpenDialog(code),
              }),
              ({ showReplace, code, id }) => ({
                icon: () => <RefreshIcon color="action" />,
                tooltip: "replace",
                hidden: !showReplace,
                position: "row",
                onClick: (newData: any) => handleOpenDialog(code, id),
              }),
              ({ showDelete, code }) => ({
                icon: () => <DeleteIcon color="action" />,
                tooltip: Labels.DELETE,
                hidden: !showDelete,
                position: "row",
                onClick: () => deleteFileGroup(code),
              }),
            ]}
            title={
              <Grid container>
                <Typography>{Labels.MANUSCRIPT_FIGURES}</Typography>
                <HtmlTooltip title={manuscriptFigures} interactive>
                  <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                </HtmlTooltip>
              </Grid>
            }
          />
          <div className={classes.buttons}>
            <Button variant="outlined" color="primary" onClick={handleBack} className={classes.button}>
              {Labels.BACK}
            </Button>
            <Button variant="contained" color="primary" className={classes.button} onClick={articleSave}>
              {Labels.NEXT}
            </Button>
          </div>
        </Paper>
        <Formik
          enableReinitialize={true}
          initialValues={{
            designation: selectedDesigantion,
            size: "",
            type: "",
            comments: "",
          }}
          onSubmit={() => {}}
        >
          {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
            <Form onKeyDown={preventDefaultEnter}>
              <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{Labels.FILE_UPLOAD}</DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Autocomplete
                        disabled={true}
                        options={designationOptions}
                        getOptionLabel={(option: any) => option.name}
                        value={values.designation}
                        onChange={(event, value) => setFieldValue("designation", value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            id="designation"
                            name="designation"
                            onBlur={handleBlur}
                            label={Labels.FILE_DESIGNATION}
                            error={touched.designation && Boolean(errors.designation)}
                            helperText={touched.designation && errors.designation}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                    <DropzoneArea
                      dropzoneProps={{ disabled: !values.designation }}
                      acceptedFiles={handleFileType(values.designation?.code)}
                      maxFileSize={SIZE_1MB * 50} //50MB
                      onChange={(files: File[]) => {
                        if (files.length > 0) {
                          handleResetDialog(
                            true,
                            setFieldValue,
                            files,
                            (files[0].size / SIZE_1MB).toFixed(2) + " mb",
                            getTypeFromNameFile(files[0].name)
                          );
                        }
                      }}
                      onDelete={(file: File) => {
                        handleResetDialog(false, setFieldValue, null, "", "");
                      }}
                      filesLimit={1}
                    />
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        margin="normal"
                        id="size"
                        name="size"
                        onBlur={handleBlur}
                        label={Labels.SIZE}
                        value={values.size}
                        error={touched.size && Boolean(errors.size)}
                        helperText={touched.size && errors.size}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        margin="normal"
                        id="type"
                        name="type"
                        label={`${Labels.FILE_TYPE}:`}
                        value={values.type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.type && Boolean(errors.type)}
                        helperText={touched.type && errors.type}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        id="comments"
                        name="comments"
                        onBlur={handleBlur}
                        label={Labels.COMMENTS}
                        error={touched.comments && Boolean(errors.comments)}
                        helperText={touched.comments && errors.comments}
                        fullWidth
                        multiline
                        rows={5}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleCloseDialog();
                      handleResetDialog(false, setFieldValue, [], "", "");
                    }}
                    color="primary"
                  >
                    {Labels.CANCEL}
                  </Button>
                  <Button
                    disabled={uploading}
                    onClick={() => uploadFile(files, values, setFieldValue)}
                    color="primary"
                    variant={"contained"}
                  >
                    {Labels.UPLOAD}
                  </Button>
                </DialogActions>
              </Dialog>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
